import AOS from 'aos';

const ERROR_MESSAGES = {
	INIT_FAILED: 'AOS: Initialization failed',
};

/**
 * Initialize AOS (Animate On Scroll) library
 * @returns {void}
 */
export const initializeAOS = () => {
	try {
		AOS.init({
			// Centralized config
			disable: 'tablet',
			startEvent: 'DOMContentLoaded',
			initClassName: 'aos-init',
			animatedClassName: 'aos-animate',
			useClassNames: false,
			disableMutationObserver: false,
			debounceDelay: 50,
			throttleDelay: 99,
			offset: 50,
			duration: 500,
			easing: 'ease',
			once: true,
			mirror: false,
			anchorPlacement: 'top-bottom',
		});
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};
